import { useContext, useState } from 'react';
import Select from 'react-select';
import { ConfigContext } from '../../../../../contexts/ConfigContext';
import { reactSelectDark } from '../../../../../styles/reactSelectDarkTheme';
import { useServicePeriodDropdown } from '../../../../../APIs/CustomSetup/servicePeriod';
import { reactSelectLight } from '../../../../../styles/reactSelectLightTheme';

export default function ServicePeriodFilter() {
  const config = useContext(ConfigContext);

  const [selectedServicePeriod, setSelectedServicePeriod] = useState(null);

  const { names: servicePeriods, isLoading } = useServicePeriodDropdown();

  const servicePeriodOptions =
    servicePeriods?.map((sp) => ({
      value: sp.name,
      label: sp.name
    })) || [];

  const handleChange = (sp) => {
    if (!sp?.value) return;

    setSelectedServicePeriod(sp);

    window.dispatchEvent(
      new CustomEvent('calendar-service-period-change', {
        detail: sp
      })
    );
  };

  return (
    <div>
      <Select
        options={servicePeriodOptions}
        value={selectedServicePeriod}
        onChange={handleChange}
        isLoading={isLoading}
        placeholder="Service Period"
        menuPortalTarget={document.body}
        styles={{
          container: (base) => ({
            ...base
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 99999
          }),
          menu: (base) => ({
            ...base,
            zIndex: 99999
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: 160
          }),

          ...(config.mode === 'dark' ? reactSelectDark : reactSelectLight),
          control: (base) => ({
            ...base,
            height: '40px',
            backgroundColor: 'transparent'
          })
        }}
      />
    </div>
  );
}
